import { useState } from 'react'
import { Link } from 'react-router-dom'

const CONSENT_KEY = 'bb-cookie-consent'

export function CookieConsentBanner() {
  const [visible, setVisible] = useState(() => localStorage.getItem(CONSENT_KEY) === null)

  if (!visible) return null

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted')
    setVisible(false)
  }

  const decline = () => {
    localStorage.setItem(CONSENT_KEY, 'declined')
    setVisible(false)
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[200] bg-bb-surface border-t-2 border-bb-orange/40 px-4 py-3 flex items-center justify-between gap-4 shadow-2xl">
      <p className="text-xs text-bb-subtle flex-1 min-w-0">
        We use analytics cookies (PostHog) to understand how people use this tool. No PII is shared —
        user IDs are hashed before transmission.{' '}
        <Link to="/privacy" className="text-bb-orange hover:underline">Privacy Policy</Link>
      </p>
      <div className="flex items-center gap-2 shrink-0">
        <button onClick={decline} className="bb-btn-ghost text-xs">Decline</button>
        <button onClick={accept} className="bb-btn-primary text-xs">Accept Cookies</button>
      </div>
    </div>
  )
}
